import { Common } from './common';
import { DetailedCoverage } from './models/realTimeEligibility/availity';
import { RealTimeEligibilityResults } from './models/realTimeEligibility/patient';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async checkRealTimeEligibility(
    patientInsuranceInformationId: string,
    npi: string,
  ): Promise<DetailedCoverage> {
    const url = this.common.constructPath('/real-time-eligibility');
    return this.common.postJSON(url, {
      patientInsuranceInformationId,
      npi,
    });
  }

  async checkPatientRealTimeEligibility(
    patientInsuranceInformationId: string,
    encounterId: string,
  ): Promise<RealTimeEligibilityResults> {
    const url = this.common.constructPath(
      '/patient-previsit/real-time-eligibility',
    );
    return this.common.postJSON(url, {
      patientInsuranceInformationId,
      encounterId,
    });
  }
}
